import * as yup from 'yup';
import { SNILS_FIELD_ERROR } from './constants';

export const snilsRegex = /^\d{3}-\d{3}-\d{3}\s\d{2}$/;

const snilsSchema = yup.string().matches(snilsRegex, SNILS_FIELD_ERROR);

export default snilsSchema;
